(function () {

  'use strict';

  // to be replaced by https://github.com/urish/angular-moment

  /**
   * @author Chester Rivas
   * @description wrapper filter for moment dates
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

    .filter('uteDateFormatter', ['moment', function (moment) {

      return function (date, dateFormat, languageKey) {

        angular.isUndefinedOrNull(dateFormat) && (dateFormat = 'LLLL'); // defaults to LLLL
        angular.isUndefinedOrNull(languageKey) && (languageKey = 'en'); // defaults to en

        var newMoment = moment(date);
        newMoment.locale(languageKey);
        return newMoment.format(dateFormat);

      };


    }]);

})();
